/**
 * Returns a unique-ish id string. Prefers `crypto.randomUUID()` (RFC 4122 v4) when available,
 * falls back to a timestamp + random suffix otherwise.
 *
 * The fallback exists because `crypto.randomUUID()` is only defined in **secure contexts**
 * (HTTPS or localhost). On a plain `http://192.168.x.x` LAN dev server or `http://staging.box`
 * it throws `TypeError: crypto.randomUUID is not a function`. Falling back keeps the import-flow
 * keyed-remount working in those environments — the returned string only needs to be unique per
 * import event, not cryptographically random.
 */
export function randomId(prefix = 'id'): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    try {
      return crypto.randomUUID()
    } catch {
      // Fall through to the timestamp+random fallback below.
    }
  }
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}
